
<div class="fixed bottom-0 right-3 z-30  my-12  animate-bounce " *ngIf="isShow" (click)="scrollToTop()" >
    <button class="bg-[#7B68EE] text-white rounded-full w-10 h-10 flex items-center justify-center" onclick="backToTop()">
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18"></path>
      </svg>
    </button>
  </div>